import firebase from 'firebase'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyD0NH7a1gt-ICDsFpG_We5T2lvZ1hF5wdI",
  authDomain: "aedes-preprod.firebaseapp.com",
  databaseURL: "https://aedes-preprod.firebaseio.com",
  projectId: "aedes-preprod",
  storageBucket: "aedes-preprod.appspot.com",
  messagingSenderId: "347141724950",
  appId: "1:347141724950:web:904f218c55710c7d"


};



firebase.initializeApp(config);
const auth = firebase.auth();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.database();
export {
  auth,
  database,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};